import type { State } from '../../Slice/index.js'

/** True from a 401 until the user is known again; consumers wait instead of refetching. */
export const selectSessionExpired = (state: typeof State): boolean => state.authentication.sessionExpired
